import type { IconTypes } from "solid-icons";
import { IoInformationCircle } from "solid-icons/io";

type DefaultIcons = "info";

export const DEFAULT_ICONS: Record<DefaultIcons, IconTypes> = {
  info: IoInformationCircle,
} as const;
